<template>
  <div id="main">
    <loader v-if="hideByRemove" />
    <div class="page" v-else>
      <div class="vertical-flow">
        <div class="listing-header">
          <div class="title-breadcrumb">
            <h1 class="title">
              {{ $t("agro-fenologia") }}
              <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                <b-icon
                  v-if="!hide.infoIsHidden"
                  icon="eye-off-outline"
                  type="is-danger"
                />
                <b-icon
                  v-if="hide.infoIsHidden"
                  icon="eye-outline"
                  type="is-success"
                />
              </a>
            </h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li>
                  <a class="a-inativo">{{ $t("agro") }}</a>
                </li>
                <li>
                  <a
                    @click="
                      $router.push({
                        name: 'agro-fenologia-list',
                      })
                    "
                  >
                    {{ $t("agro-fenologia") }}
                  </a>
                </li>
                <li>
                  <a aria-current="page">{{
                    $route.params.id
                      ? $route.params.id
                      : `${$t("novo")} ${$t("agro-fenologia")}`
                  }}</a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="header-buttons">
            <button
              class="delete-btn"
              type="button"
              tag="button"
              @click="redirectToList()"
            >
              {{ $t("voltar") }}
            </button>
            <button
              v-if="isUpdate && situacao == 4"
              :disabled="cantEdit"
              class="save-btn"
              type="button"
              tag="button"
              @click="updateSituacao = true"
            >
              {{ $t("finalizar") }}
            </button>
            <button
              v-if="isUpdate && situacao == 4"
              :disabled="cantEdit"
              class="save-btn excluir-fenologia"
              type="button"
              tag="button"
              @click="deleteFenologia = true"
            >
              {{ $t("excluir") }}
            </button>
          </div>
        </div>

        <ul
          class="nav nav-tabs nav-tabs-children"
          v-if="isUpdate"
          key="agro-fenologia-manage"
        >
          <li
            v-for="(aba, i) in abas"
            :key="i"
            v-show="permissao.read"
            :class="{ active: abaSelecionada == i }"
            @click="changeTab(i)"
          >
            <a data-toggle="tab">
              <span v-if="aba.icone" class="icon" :style="{ color: aba.cor }">
                <i :class="aba.icone.toLowerCase()" />
              </span>
              {{ $t(aba.descricao) ? $t(aba.descricao) : aba.descricao }}
            </a>
          </li>
        </ul>

        <!-- CONJUNTO DE ABAS - MOBILE -->
        <b-dropdown
          aria-role="list"
          class="mobile-tab-list"
          key="agro-fenologia-manage-mobile"
        >
          <div slot="trigger" class="mobile-tab">
            <span class="mobile-tab-text">
              <span
                v-if="abas[abaSelecionada].icone"
                class="icon"
                :style="{ color: abas[abaSelecionada].cor }"
              >
                <i :class="abas[abaSelecionada].icone.toLowerCase()" />
              </span>
              {{
                $t(abas[abaSelecionada].descricao)
                  ? $t(abas[abaSelecionada].descricao)
                  : abas[abaSelecionada].descricao
              }}
            </span>
            <em class="mdi mdi-chevron-down"></em>
          </div>

          <b-dropdown-item
            class="mobile-tab-list-item"
            :class="{ active: abaSelecionada == i }"
            aria-role="listitem"
            v-for="(aba, i) in abas"
            v-show="permissao.read"
            :key="i"
            @click="changeTab(i)"
          >
            {{ $t(aba.descricao) ? $t(aba.descricao) : aba.descricao }}
          </b-dropdown-item>
        </b-dropdown>
        <div class="aba-fenologia">
          <Geral
            ref="tabGeral"
            v-if="abasAbertas[0] && !newToEdit && permissao.read"
            v-show="abas[abaSelecionada].id == 0"
            :isUpdate="isUpdate"
            :cantEdit="cantEdit"
            @isChanged="isChanged = $event"
            @redirectList="redirectToList"
            :updateSituacao="updateSituacao"
            :deleteFenologia="deleteFenologia"
            @cantEdit="cantEdit = $event"
            @situacao="situacao = $event"
            @onFenologiaUpdate="onFenologiaUpdate"
            @alterDeleteFenologia="deleteFenologia = false"
            @alterFinalizarFenologia="updateSituacao = false"
            :existeFenologiaItem="fenologiaitens.length > 0"
          />

          <FaseFenologica
            ref="tabFaseFenologica"
            v-if="abasAbertas[1] && !newToEdit && permissao.read"
            v-show="abas[abaSelecionada].id == 1"
            :isUpdate="isUpdate"
            :cantEdit="cantEdit"
            @isChanged="isChanged = $event"
            @redirectList="redirectToList"
            :fenologia="fenologia"
            @atualizarItens="carregarDados"
            :fenologiaitens="fenologiaitens"
            :totalRows="totalRows"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";

// Abas
import Geral from "@/components/agro/fenologia/abas/Geral";
import FaseFenologica from "@/components/agro/fenologia/abas/FaseFenologica.vue";
import AgroFenologiaItemService from "@/services/agro/fenologia/AgroFenologiaItemService";

export default {
  beforeRouteLeave(to, from, next) {
    if (from.name == "agro-fenologia-new" && to.name == "agro-fenologia-edit") {
      this.isUpdate = true;

      this.newToEdit = true;
      setTimeout(() => {
        this.newToEdit = false;
      }, 500);
    }
    if (this.isChanged) {
      this.promptChangeTab(next);
    } else {
      next();
    }
  },
  components: {
    HideInfo,
    Geral,
    FaseFenologica,
  },
  data() {
    return {
      abaSelecionada: 0,
      fenologia: {},
      abas: [
        {
          id: 0,
          descricao: "dados-cadastrais",
        },
        {
          id: 1,
          descricao: "fasefenologica",
        },
      ],
      abasAbertas: {},
      isUpdate: false,
      isChanged: false,
      newToEdit: false,
      permissao: false,
      cantEdit: false,
      situacao: null,
      updateSituacao: false,
      deleteFenologia: false,
      hideByRemove: false,
      existeFenologiaItem: false,
      service: new AgroFenologiaItemService(this.$http, this.$router),
      fenologiaitens: [],
      totalRows: 0,
    };
  },
  mounted() {
    if (this.$route.query.abaSelecionada) {
      this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
    }
  },
  computed: {
    ...mapState(["hide"]),
  },
  watch: {
    situacao(val) {
      if (val != 4) this.cantEdit = true;
    },
  },
  created() {
    if (this.$route.params.id) this.isUpdate = true;

    this.permissao = this.hasPermissionAccess(
      "agro",
      "agro-fenologia",
      "agro-fenologia"
    );

    if (
      (!this.isUpdate && !this.permissao.create) ||
      (this.isUpdate && !this.permissao.read)
    ) {
      this.$router.push({
        name: "acesso-nao-permitido",
        params: { tela: "agro-fenologia" },
      });
    } else {
      this.cantEdit =
        (!this.$route.params.id && !this.permissao.create) ||
        (this.$route.params.id && !this.permissao.update);

      this.abasAbertas[0] = true;
      this.abasAbertas[1] = false;
      this.carregarDados();
    }
  },
  methods: {
    onFenologiaUpdate(fenologia) {
      this.fenologia = fenologia;
    },
    infoIsHidden() {
      this.$store.dispatch("infoIsHidden", {
        infoIsHidden: !this.hide.infoIsHidden,
      });
    },
    changeTab(i) {
      this.abaSelecionada = i;
      this.abasAbertas[this.abas[this.abaSelecionada].id] = true;
    },
    promptChangeTab(next) {
      this.$root.confirm({
        message: this.$t("msg-tem-certeza-alteracoes"),
        onConfirm: (_) => {
          this.isChanged = false;
          next();
        },
        onCancel: (_) => {
          next(false);
        },
      });
    },
    redirectToList() {
      if (this.$route.query.tela) {
        let tempTela = null;
        let tempAba = null;
        let tempId = null;
        if (tempTela != null) {
          setTimeout(() => {
            this.$router.push({
              name: tempTela,
              params: { id: tempId },
              query: { abaSelecionada: tempAba },
            });
          }, 1000);
        } else {
          this.$router.push({ name: "agro-fenologia-list" });
        }
      } else {
        this.$router.push({ name: "agro-fenologia-list" });
      }
    },
    removeAba() {
      this.hideByRemove = true;
      this.abaSelecionada = 0;
      this.abas = [{ id: 0, descricao: "dados-cadastrais" }];
      this.abasAbertas = {};
      this.abasAbertas[0] = true;
      this.tiposOcorrencias = [];
      this.cantEdit = false;
    },
    carregarDados(page) {
      this.service
        .findAll(
          this.$route.params.id,
          this.column,
          this.order,
          page ? page.pagina - 1 : 0,
          page ? page["por-pagina"] : 10
        )
        .then((value) => {
          this.fenologiaitens = value.content;
          this.totalRows = value.totalElements;
        })
        .catch((e) => {
          this.$root.showMessage("error", "msg-erro-load");
          console.error("Erro ao carregar as as fases fenológicas.");
        })
        .finally(() => {
          this.isLoading = false;
          if (page) {
            page.done();
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
#main {
  padding: 0 20px;
  height: 100%;

  .page {
    position: relative;
    padding-left: 0;
    .nav-tabs-children {
      margin-bottom: 20px;
      li > ::after {
        bottom: -4px;
        border-width: 2px;
      }
    }

    .mobile-tab {
      cursor: pointer;

      &-list {
        width: calc(100% + 40px);
        margin-top: 20px;
        margin-bottom: 20px;
        margin-left: -20px;
        padding-right: 20px;
        padding-bottom: 5px;
        padding-left: 20px;
        border-bottom: 1px solid $table-border;
        justify-content: center;

        &::after {
          content: "";
          border: 3px solid $primary-color-click;
          border-radius: 100px;
          position: absolute;
          width: calc(100% - 40px);
          bottom: -3px;
        }

        &-item {
          text-transform: uppercase;
          font-weight: 600;
          color: $text-color;

          &.active {
            color: $primary-color-click;
          }
        }
      }

      &-text {
        text-transform: uppercase;
        font-weight: 600;
        color: $primary-color-click;

        & ~ i {
          color: $primary-color-click;
        }
      }
    }
  }
}

@media only screen and (max-width: 760px) {
  .nav.nav-tabs-main {
    display: flex;
    justify-content: center;
    padding: 0;
    margin: 0;

    &::after {
      display: none;
    }
  }

  .nav.nav-tabs.nav-tabs-children {
    display: none;
  }
}

@media only screen and (min-width: 761px) {
  .mobile-tab-list {
    display: none;
  }
}
.aba-fenologia {
  height: 100%;
}
.excluir-fenologia {
  background-color: #f44336;

  &:hover {
    background-color: #ef8078;
  }
}
</style>
